import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulevartComponent } from './bulevart.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddBulevartImageComponent } from './add-bulevart-image/add-bulevart-image.component';
import { ViewBulevartImageComponent } from './view-bulevart-image/view-bulevart-image.component';
import { EditBulevartImageComponent } from './edit-bulevart-image/edit-bulevart-image.component';


@NgModule({
    declarations: [
        BulevartComponent,
        AddBulevartImageComponent,
        ViewBulevartImageComponent,
        EditBulevartImageComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        BulevartComponent,
    ]
})
export class BulevartModule { }
